<template>
  <div class="authority-distribute-catalog">
    <div class="header">
      <el-input v-model="filterKey"
                size="mini"
                placeholder="筛选权限目录"
                clearable>
      </el-input>
    </div>
    <div class="main">
      <div class="main-cont">
        <AppScrollbar style="height: 100%">
          <el-tree ref="catalogTree"
                   :data="catalogTreeList"
                   :default-checked-keys="distributes"
                   node-key="id"
                   :filter-node-method="filterNodes"
                   :props="defaultProps"
                   empty-text="没有可分配的权限目录"
                   default-expand-all
                   expand-on-click-node
                   show-checkbox
                   check-strictly>
            <template #default="{node, data}">
              <span class="custom-tree-node">
                <span :class="{'is-invisible': !data.isShow, 'is-submenu': !data.isMainMenu}">
                  <i :class="data.icon"></i>
                  <span>{{node.label}}</span>
                </span>
                <span class="extra">
                  <slot name="custom"
                        :node="node"
                        :data="data"></slot>
                </span>
              </span>
            </template>
          </el-tree>
        </AppScrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import AppScrollbar from '../../elements/AppScrollbar'
export default {
  name: 'AuthorityDistributeCatalog',
  components: {
    AppScrollbar
  },
  props: {
    catalogList: {
      type: Array,
      required: true
    },
    distributes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      filterKey: '',
      defaultProps: {
        label: 'name',
        children: 'children',
        disabled: data => !this.isChildNode(data)
      }
    }
  },
  computed: {
    catalogTreeList: function () {
      let catalogList = this.catalogList
      if (catalogList) {
        let catalogs = []
        catalogList.forEach(value => {
          if (!value.parentId) {
            if (this.computeTreeNode(value, catalogList)) {
              catalogs.push(value)
            }
          }
        })
        return catalogs
      } else {
        return null
      }
    }
  },
  methods: {
    isChildNode (data) {
      return !!data.typeCode
    },
    computeTreeNode (parentNode, dataList) {
      let childNode = []
      dataList.forEach(value => {
        if (value.parentId === parentNode.id) {
          if (this.computeTreeNode(value, dataList)) {
            childNode.push(value)
          }
        }
      })
      if (childNode.length) {
        parentNode['children'] = childNode
        return true
      } else {
        return this.isChildNode(parentNode)
      }
    },
    filterNodes (value, data) {
      return !value || data.name.includes(value)
    },
    selectAll () {
      let catalogTree = this.$refs.catalogTree
      if (catalogTree) {
        let catalogList = this.catalogList
        if (catalogList) {
          let catalogIds = catalogList.filter(catalog => this.isChildNode(catalog))
            .map(catalog => catalog.id)
          catalogTree.setCheckedKeys(catalogIds)
        }
      }
    },
    clearSelection () {
      let catalogTree = this.$refs.catalogTree
      if (catalogTree) {
        catalogTree.setCheckedKeys([])
      }
    },
    getDistributeCatalogs () {
      return new Promise((resolve, reject) => {
        let getSelection = []
        let checkedNodes = this.$refs.catalogTree.getCheckedNodes()
        checkedNodes.forEach(value => {
          if (this.isChildNode(value)) {
            getSelection.push(value.id)
          }
        })
        let distributes = this.distributes || []
        let addIds = []
        getSelection.forEach(value => {
          if (!distributes.includes(value)) {
            addIds.push(value)
          }
        })
        let deleteIds = []
        distributes.forEach(value => {
          if (!getSelection.includes(value)) {
            deleteIds.push(value)
          }
        })
        if (!addIds.length && !deleteIds.length) {
          reject(new Error('权限目录分配未变化'))
        } else {
          resolve({addIds, deleteIds})
        }
      })
    }
  },
  watch: {
    catalogList: function () {
      this.filterKey = ''
    },
    filterKey: function (val) {
      this.$refs.catalogTree.filter(val)
    }
  }
}
</script>

<style lang="scss">
  .authority-distribute-catalog {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 10px;
      .el-input {
        .el-input__inner {
          border-radius: 20px;
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .el-tree {
          min-height: 150px;
          background-color: transparent;
          .el-tree-node {
            & > .el-tree-node__content {
              height: 28px;
              & > .el-checkbox {
                &.is-disabled {
                  display: none;
                }
              }
            }
          }
          .el-tree__empty-block {
            min-height: 150px;
            & > .el-tree__empty-text {
              font-size: 12px;
            }
          }
          .custom-tree-node {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #303133;
            font-size: 13px;
            padding-right: 10px;
            i {
              font-size: 14px;
              vertical-align: -1px;
            }
            .is-invisible {
              color: #e6a23c;
            }
            .is-submenu {
              opacity: .6;
              span {
                font-size: 12px;
                vertical-align: 1px;
              }
            }
          }
        }
      }
    }
  }
</style>
